// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ih3Qa1rbu5uFML {
  word-break: break-word;
}
.XA_g0Nv7k1yC9v {
  display: none;
}
.Ih3Qa1rbu5uFML:hover .XA_g0Nv7k1yC9v {
  display: inline-block;
}
.yB1s79crtI8YFz {
  display: flex;
}
.Qw9iTBm5vhCRhY {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.Qw9iTBm5vhCRhY:hover {
  color: var(--ds-text-subtle, #44546f);
}
.MMQNgts4HACDc_ div[role='button'] > a > img {
  max-width: 264px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Ih3Qa1rbu5uFML`,
	"copyLinkWrapper": `XA_g0Nv7k1yC9v`,
	"descriptionWrapper": `yB1s79crtI8YFz`,
	"replyButton": `Qw9iTBm5vhCRhY`,
	"boardActionWrapper": `MMQNgts4HACDc_`
};
export default ___CSS_LOADER_EXPORT___;
